import { SearchTerm } from "./SearchTerm";

const AbsenteeismReportSearch: SearchTerm[] = [
    {
        heading: "Unique Identifier",
        accessor: "uniqueIdentifier",
        searchOnName: "mstIdnumber",
        translationKey: "uniqueIdentifier"
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        searchOnName: "mstDisplayname",
        translationKey: "displayName"
    },
    {
        heading: "First Name",
        accessor: "firstName",
        searchOnName: "mstFirstname",
        translationKey: "firstName"
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        searchOnName: "mstLastname",
        translationKey: "lastName"
    },
    {
        heading: "Department",
        accessor: "department",
        searchOnName: "deptName",
        translationKey: "department"
    },
    {
        heading: "Company",
        accessor: "company",
        searchOnName: "compName",
        translationKey: "company"
    },
    {
        heading: "Category",
        accessor: "category",
        searchOnName: "pNameOriginal",
        translationKey: "category"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        searchOnName: "mstMiddlename",
        translationKey: "secondName"
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        searchOnName: "mstSuffix",
        translationKey: "suffix"
    },
    {
        heading: "Access Type",
        accessor: "access",
        searchOnName: "mtName",
        translationKey: "accessType"
    },
    {
        heading: "Gender",
        accessor: "gender",
        searchOnName: "mstGender",
        translationKey: "gender"
    }]

export default AbsenteeismReportSearch;
